import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";

export const ServiceTypeFacetCodec = t.intersection([
  t.type({
    id: t.string,
    companyId: t.string,
    serviceTypeId: t.string,
    facet: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    resetStatus: t.string,
    defaultBaselineStatus: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type ServiceTypeFacet = t.TypeOf<typeof ServiceTypeFacetCodec>;

@Exclude()
export class ServiceTypeFacetEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  companyId!: string;

  @Expose()
  serviceTypeId!: string;

  @Expose()
  facet!: string;

  @Expose()
  resetStatus?: string;

  @Expose()
  defaultBaselineStatus?: string;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'SERVICETYPEFACET';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceTypeFacetEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ServiceTypeFacet): ServiceTypeFacetEntity {
    return plainToInstance(ServiceTypeFacetEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ServiceTypeFacet> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceTypeFacetCodec, object);
  }

  asTypeValue(): ServiceTypeFacet {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ServiceTypeFacetCodec, object);
  }
}

export type ServiceTypeFacetSaveDTO = {
  companyId: string,
  serviceTypeId: string,
  facet: string
  resetStatus?: string;
  defaultBaselineStatus?: string;
}
